<!--
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="page-title">{{ $t('rjcp.text1') }}</div>
    <div style="background-size: cover;background-position: top;background-image: url('/static/images/v2/rjcp/rj_bg1.png');padding-top: 30px;padding-bottom:100px ">
      <div v-for="(item,index) in $t('rjcp.list') " :key="index"  class="main-box">
        <div class="box-content1">
          <div class="content-left">
            <img :src="item.url" class="left-img">
          </div>
          <div class="content-right">
            <div class="dc-title">{{ item.title }}</div>
            <div class="dc-name">{{ item.name }}</div>
            <div class="dc-text-box">
              <div v-for="(i,k) in item.info " :key=k class="dc-text">{{ i }}</div>
            </div>
            <div class="list-box">
              <div class="list-item" v-for="(i,k) in item.ts " :key=k>
                <div style="width: 6px;height: 6px;border-radius: 3px;background: #000000;opacity: 0.2;margin-right: 8px;margin-top: 5px"></div>
                {{i}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {

    };
  },
  watch: {
    $route(to, from) {
      if (to.name === 'rjcp2') {
        window.scrollTo(0, 660);
      } else if (to.name === 'rjcp3') {
        window.scrollTo(0, 1290);
      }
    },
  },
  mounted() {
    let name=this.$route.name;
    if (name === 'rjcp2') {
      window.scrollTo(0, 660);
    } else if (name === 'rjcp3') {
      window.scrollTo(0, 1290);
    }
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.template-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
 background: #e3e3e3;

  .page-title {
    z-index: 100;
    top: 22px;
    font-size: 14px;
    font-weight: 600;
    color: #3D3D3D;
    width: 1280px;
    margin-left: calc((100% - 1280px) / 2);
    position: absolute;
  }

  .main-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 30px;

    .box-content1 {
      display: flex;
      border-radius: 10px;
      width: 1280px;
      height: 600px;
      background: #3a8ee6;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 5%, rgba(255, 255, 255, 0.85) 96%);
    }

    .box-content2 {
      width: 1280px;
      height: 600px;
      background: #3a8ee6;
    }

    .content-left {
      flex: 1;
    }

    .left-img {
      margin-top: 44px;
      margin-left: 56px;
      width: 710px;
      height: 455px;
    }

    .content-right {
      display: flex;
      flex-direction: column;
      margin-top: 67px;
      margin-bottom: 31px;
      width: 482px;
      .list-box{
        margin-top: 50px;
        .list-item{
          margin-top: 9px;
          display: flex;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 20px;
        }
      }
    }

    .dc-title {
      line-height: 40px;
      width: 350px;
      font-size: 32px;
      font-weight: 600;
      color: #1F65FE;
      margin-bottom: 12px;
    }

    .dc-name {
      margin-bottom: 15px;
      font-size: 20px;
      font-weight: 600;
      color: #1F65FE;
    }

    .dc-text-box {
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      margin-right: 50px;
      padding-left: 23px;
      color: #999999;
      border-left: 3px solid #D6D6D6;
    }

    .dc-text {
      margin-bottom: 10px;
      font-weight: 600;
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #e3e3e3;

    .page-title {
      display: none;
      z-index: 100;
      top: 22px;
      font-size: 14px;
      font-weight: 600;
      color: #3D3D3D;
      width: 100%;
      margin-left: calc((100% - 1280px) / 2);
      position: absolute;
    }

    .main-box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 30px;

      .box-content1 {
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:90%;
        height: auto;
        background: #3a8ee6;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 5%, rgba(255, 255, 255, 0.85) 96%);
      }

      .box-content2 {
        width: 100%;
        height: 600px;
        background: #3a8ee6;
      }

      .content-left {
        flex: 1;
      }

      .left-img {
        margin-top: 5%;
        margin-left: 5%;
        width: 90%;
        height: auto;
      }

      .content-right {
        display: flex;
        flex-direction: column;
        margin-top: 27px;
        margin-bottom: 31px;
        width: auto;
        .list-box{
          margin-left: 20px;
          margin-top: 50px;
          .list-item{
            margin-top: 29px;
            display: flex;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 20px;
          }
        }
      }

      .dc-title {
        margin-left: 20px;
        line-height: 40px;
        width: auto;
        font-size: 32px;
        font-weight: 600;
        color: #1F65FE;
        margin-bottom: 12px;
      }

      .dc-name {
        margin-bottom: 15px;
        font-size: 20px;
        font-weight: 600;
        color: #1F65FE;
      }

      .dc-text-box {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        margin-right: 50px;
        padding-left: 23px;
        color: #999999;
        border-left: 0px solid #D6D6D6;
      }

      .dc-text {
        margin-bottom: 10px;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/rjcp/index.vue